var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-form-rating',{attrs:{"id":"rating-inline","inline":"","value":_vm.rateValue,"color":"#EF4923","size":"lg"},on:{"change":_vm.changevalue,"click":function($event){return _vm.testMe()}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }